module.exports = __webpack_public_path__ + "static/media/insitu_pro_wor_pla.533c6316.png";